export default {
    path: "crm",
    permit: "system.crm",
    menu: { title: "CRM" },
    name: "crmvip",
    component: () => import("@/views/crm/vip/index.vue")
};
